<template>
  <v-avatar size="50" color="white">
    <img
    @error="profileImageUrl = ''"
    :src="profileImageUrl"
    v-if="profileImageUrl !== ''"
    class="profileImage" />
    <img src="@/assets/images/avatar.jpg" v-if="profileImageUrl === ''" class="profileImage" />
  </v-avatar>
</template>
<script>
import {getStaffProfileImage} from '@/utils/common.js'
export default {
  data () {
    return {
      profileImageUrl: '',
      userDetail: {}
    }
  },
  mounted () {
    let userData = localStorage.getItem('loginuserData')
    this.userDetail = JSON.parse(userData)
    this.profileImageUrl = getStaffProfileImage(this.userDetail.staffId, 'small')
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/View/components/loginStaffProfileImage.vue